export default "__VITE_ASSET__Bnqw4Rv3__"